import { Injectable } from "@angular/core";
import { apiconstants } from "../constants/api.constant";
import { Observable, map } from 'rxjs';
import { IResponse } from '../models/response';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: "root",
})
export class ReportService {

  constructor(private _http: HttpClient) { }

  getAllReportsByDepartmentId(departmentId: string): Observable<any> {
    return this._http.get(apiconstants.API_GET_REPORTS + `/${departmentId}`).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  uploadReport(params) {
    return this._http.post(apiconstants.API_REPORT, params).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  getNoteReports(params) {
    return this._http.get(apiconstants.API_APPOROVAL_REQUEST_REPORT, { params }).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  saveReportToFolder(params) {
    return this._http.post(apiconstants.API_SAVE_REPORT_TO_FOLDER, params).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

  getAllConfigRecords() {
    return this._http.get(apiconstants.API_GET_ALL_CONFIG_RECORDS).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  getReportFiltersFromConfig(reportId) {
    return this._http.get(apiconstants.API_GET_FILTER_FROM_CONFIG + '/' + reportId).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  getExecutedData(fetchXML) {
    let params = {
      fetchxml: fetchXML
    }
    return this._http.get(apiconstants.API_GET_EXECUTED_DATA, { params }).pipe(
      map((response: IResponse) => {
        return response.data;
      })
    );
  }

  generateReport(reportid = null, filters = []) {
    let params = {
      reportid,
      filters
    }
    return this._http.post(apiconstants.API_GENERATE_REPORT, params).pipe(
      map((response: IResponse) => {
        return response;
      })
    );
  }

}
